import React, { useContext, useState } from 'react'
import './Navbar.scss';
import logo from '../../logo.png';

import { Link, useLocation, useHistory } from "react-router-dom";
import AuthContext from "../../Store/auth-context";

import Announcement from '../Announcement/Announcement';

function Navbar() {
    const { logout } = useContext(AuthContext);
    const history = useHistory();

    const [navbar, setNavbar] = useState(false)

    const changeBackground = () => {
        if (window.scrollY >= 18) {
            setNavbar(true)
        } else {
            setNavbar(false)
        }
    }

    const SignOut = () => {
        logout();
        history.replace("/");
    };

    window.addEventListener('scroll', changeBackground);
    const authCtx = useContext(AuthContext);
    const location = useLocation();

    // className={navbar ? 'navbar navbar-expand-md navbar-dark bg-custom fixed-top' : 'navbar navbar-expand-md navbar-dark bg-custom navbarScroll fixed-top'}
    return (
        <div id='navbar'>
            <div className='fixed-top'>
                <Announcement />
                <nav
                    className='navbar navbar-expand-md navbar-dark bg-custom'>
                    <div className="container-fluid navbarWidth">
                        <Link to='/'><img className="navlogo" src={logo} alt="logo" /></Link>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarCollapse"
                            aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarCollapse">
                            <ul className="navbar-nav ms-auto pe-3 mt-1 mb-md-0">
                                <li className="nav-item ml-md-2">
                                    <a className="nav-link" href="/previous-picks">Previous Picks</a>
                                </li>
                            </ul>
                            {/* <form className="d-flex">
                                <Link to='/login'>
                                    <button className="btn loginButton text-nowrap">Log In</button>
                                </Link>
                                <Link to='/register'>
                                    <button className="btn joinButton text-nowrap">Sign Up</button>
                                </Link>
    </form> */}
                            {
                                location.pathname === "/register/" ?
                                    <form className="d-flex">
                                        <Link to='/login'>
                                            <button className="btn loginButton text-nowrap">Log In</button>
                                        </Link>
                                        <Link to='/register'>
                                            <button className="btn joinButton text-nowrap">Sign Up</button>
                                        </Link>
                                    </form> :
                                    <div className="d-flex">
                                        {
                                            authCtx.isActive ? <Link to='/dashboard'>
                                                <button className="btn joinButton text-nowrap">Dashboard</button>
                                            </Link> :
                                                [authCtx.isLoggedIn ?
                                                    <div>
                                                        <button className="btn loginButton text-nowrap" onClick={SignOut}>Sign Out</button>
                                                        <a href='#pricing'>
                                                            <button className="btn joinButton text-nowrap">Join Us</button>
                                                        </a>
                                                    </div> : <div>
                                                        <Link to='/login'>
                                                            <button className="btn loginButton text-nowrap">Log In</button>
                                                        </Link>

                                                        <Link to='/register'>
                                                            <button className="btn joinButton text-nowrap">Sign Up</button>
                                                        </Link>
                                                    </div>]

                                        }
                                    </div>
                            }


                        </div>
                    </div>
                </nav>
            </div>
        </div>
    )
}

export default Navbar
